import type { TDocumentosPessoa } from '@/features/enviar-documentos/interfaces'
import type { TTipoDocumento } from '@/shared/interfaces/documentos.enums'
import { HttpService } from '@/shared/lib'

export interface TDocumentoLeadRepresado {
  tipo: TTipoDocumento
  dataEnvio: string
}

export interface TGetDocumentosLeadRepresadoResponse {
  documentos: TDocumentoLeadRepresado[]
}

export class GetDocumentosLeadRepresadoService extends HttpService {
  execute = async (clienteId: string) => {
    return this.http.get<TDocumentosPessoa>(`/api/v2/Cliente/leadRepresado/${clienteId}/documentos`)
  }
}
